import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IFormDelegate, IFormOptions } from '@modeso/aumico-lib-core-fe';
import { IDynamicKeyValue } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextService } from 'angular-i18next';
import fastDeepEqual from 'fast-deep-equal/es6';
import { distinctUntilChanged } from 'rxjs/operators';

@UntilDestroy()
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'templates-change-caption-form',
    templateUrl: 'change-caption-form.dialog.html',
    styleUrls: ['change-caption-form.dialog.scss'],
})
export class ChangeCaptionFormDialog implements OnInit {
    private _caption: IDynamicKeyValue;
    public get caption(): IDynamicKeyValue {
        return this._caption;
    }
    @Input()
    public set caption(value: IDynamicKeyValue) {
        this._caption = value;
        this.newState.caption = value;
    }

    @Input()
    private _name: string;
    public get name(): string {
        return this._name;
    }
    public set name(value: string) {
        this._name = value;
        this.newState.name = value;
    }

    private currentUsedLanguage = 'de-ch';
    @Input() set currentLanguage(value: string) {
        if (value != null) {
            this.currentUsedLanguage = value;
        }
    }

    @Input() defaultLanguage = 'de-ch';
    @Input() type: string;

    @Output()
    saveEvent = new EventEmitter<IDynamicKeyValue>();

    formDelegate: IFormDelegate;
    newState: {
        name: string;
        caption: { [key: string]: string };
    } = { name: this.name, caption: this.caption };

    options: IFormOptions;

    private readonly localizationKeys = [];

    constructor(private localizedTexts: I18NextService) {
        this.applyLocalizations();
    }

    savePressed(result: ChangeCaptionFormDialog['newState']) {
        this.newState.caption = result.caption;
        this.saveEvent.emit(result.caption);
    }

    ngOnInit(): void {
        this.prepareFields();
        const that = this;
        this.formDelegate = {
            onSubmit(result, formOptions) {
                that.savePressed(result);
            },
        };
    }


    private applyLocalizations(): void {
        if (this.newState != null && this.newState.caption != null) {
            this.prepareFields();
        }
    }

    private prepareFields(): void {
        this.options = {
            properties: [
                {
                    name: this.localizedTexts.t('aumico_templates_name') as string,
                    type: 'label',
                    property: 'name',
                    required: true,
                },
                {
                    name: this.localizedTexts.t('aumico_templates_caption') as string,
                    type: 'translatable-text',
                    property: 'caption',
                    required: true,
                    languages: this.getTabsNames(),
                },
            ],
            submitText: this.localizedTexts.t('aumico_templates_save') as string,
        };
    }

    private getTabsNames(): string[] {
        if (this.currentUsedLanguage !== this.defaultLanguage) {
            return [this.defaultLanguage, this.currentUsedLanguage];
        } else {
            return [this.defaultLanguage];
        }
    }
}
